import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'components/Luxkit/Typography/BodyText'
import FormatCurrency from 'components/Common/FormatCurrency'
import Clickable from 'components/Common/Clickable'
import { pluralizeToString } from 'lib/string/pluralize'
import cx from 'clsx'

const Card = styled(Clickable)`
  padding: ${rem(12)} ${rem(32)};
  border: 1px solid ${(props) => props.theme.palette.neutral.default.five};
  border-radius: ${props => props.theme.borderRadius.S};
  background: ${(props) => props.theme.palette.neutral.default.eight};

  &.card-selected{
    border-color: ${(props) => props.theme.palette.neutral.default.one};
  }
`

interface Destination {
  label: string;
  id: string;
  name: string;
}

interface Props {
  destination: Destination;
  departure: App.CruiseDepartureDetails;
  isSelected: boolean;
  onClick?: () => void;
  departuresAmount: number;
  cachedDepartures: { [cabinCategory: string]: App.CruisePriceDetails };
}

function CruiseDepartureDatesTabItem({
  destination,
  departure,
  isSelected,
  onClick,
  departuresAmount,
  cachedDepartures,
}: Props) {
  const lowestPrice = departure.lowestOverallPriceDetails

  // TODO: This code is very confusing, needs refactoring
  const cachedValue = cachedDepartures[departure.id]
  if (cachedValue) {
    let idx = 0
    for (const k in cachedValue) {
      if (cachedValue[k].total < lowestPrice.total || idx === 0) lowestPrice.total = cachedValue[k].total
      idx++
    }
  }

  return (
    <Card onClick={onClick} key={destination.id} className={cx({ 'card-selected': isSelected })}>
      <BodyText variant="large" weight="bold" align="center">
        {destination.label}
      </BodyText>
      <BodyText
        variant="small"
        weight="bold"
        colour={isSelected ? 'neutral-one' : 'neutral-two'}
        align="center"
      >
        <FormatCurrency value={lowestPrice?.total ?? 0} />
        <BodyText weight="normal" variant="small">
          {departuresAmount > 1 && pluralizeToString('trip', departuresAmount)}
        </BodyText>
      </BodyText>
    </Card>
  )
}

export default CruiseDepartureDatesTabItem
